import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Activity} from '../models';
import {environment} from '~environments/environment';

/**
 * Returns activity history for the customer.
 */
@Injectable()
export class ActivityHistoryService {
  public API_URL: any = `${environment.envAPI}`;

  public activityHistory: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public castActivityHistory: any = this.activityHistory.asObservable();

  constructor(private http: HttpClient) {
  }

  /**
   * Returns the activity history.
   * With this you can then create the pagination.
   *
   * @param parentId ID of the customer
   * @param page Page number
   * @param limit Items per page
   */
  public getCustomerHistory(
    parentId: string,
    page: number = 1,
    limit: number = 3
  ): Observable<HttpResponse<any>> {
    const pageStr = String(page);
    const limitStr = String(limit);

    const params: HttpParams = new HttpParams({
      fromObject: {
        parentId,
        'page': pageStr,
        'itemsPerPage': limitStr,
        'order[createdAt]': 'desc'
      }
    });

    return this.http.get<any>(`${this.API_URL}/audits`, {params});
  }

  /**
   * Adds values to the observer.
   */
  public announce(activity: Activity): void {
    this.activityHistory.next(activity);
  }
}
